import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { datadogRum } from "@datadog/browser-rum";

import "tailwindcss/tailwind.css";

import App from "@/components/App";
import usePluginsStore from "@/store/PluginsStore";
import { APP_VERSION } from "@/constants/app";

import "./main.scss";
import {
  IS_SENTRY_ENABLED,
  SENTRY_DSN,
  SENTRY_MODE,
  IS_DATADOG_ENABLED,
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  DATADOG_SITE,
  DATADOG_SERVICE,
  DATADOG_ENV,
} from "@/config";

// other styles
import "react18-json-view/src/style.css";
import "react18-json-view/src/dark.css";

const container = document.getElementById("root") as HTMLDivElement;
const root = createRoot(container);

if (IS_SENTRY_ENABLED) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: SENTRY_MODE,
    release: APP_VERSION,
  });
}

if (IS_DATADOG_ENABLED) {
  datadogRum.init({
    applicationId: DATADOG_APPLICATION_ID!,
    clientToken: DATADOG_CLIENT_TOKEN!,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE,
    env: DATADOG_ENV,
    version: APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackBfcacheViews: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
  });

  // Lightweight console log to confirm initialization in browser
  // (safe: no secrets, only service/env/version)
  console.info("Datadog RUM initialized", {
    service: DATADOG_SERVICE,
    env: DATADOG_ENV,
    version: APP_VERSION,
  });

  datadogRum.startSessionReplayRecording();
}

usePluginsStore.getState().setupPlugins(import.meta.env.MODE);
root.render(<App />);
